import locale from 'live/init/global-locale'
import i18n from 'live/services/i18n'
import LoggerFactory from 'live/services/logger'
import serviceLocator from 'live/services/service-locator'

import { IUpdateModeFrontPresenter, UpdateModeFrontAPI } from 'plugin-codaf-risk-ext-bowtie/shared/UpdateModeFrontAPI'
import { IBarrier } from 'plugin-codaf-risk-ext-bowtie/types'

import { enUS, ptBR } from './i18n'
import { QuantitativeRuledChannelsApi, IRuledChannelSetting } from './updateMode/QuantitativeRuledChannelsApi'
import { isNullOrUndefined, isNullOrUndefinedOrEmpty } from './utils'

export const logger = LoggerFactory('plugin-quantitative-ruled-channel-dra-engine')

const locales = { pt_br: ptBR, en_us: enUS }
i18n.add(locales[locale ?? 'en_us'])

function requestValidationArray(barrier: IBarrier): string[] {
    const errorsArray: string[] = []
    const updateModeJsonConfig = barrier.updateModeJsonConfig as IRuledChannelSetting
if(updateModeJsonConfig === null || updateModeJsonConfig ===undefined){
    errorsArray.push(i18n('updateModeJsonConfig'))
    return errorsArray
}
    if (isNullOrUndefinedOrEmpty(updateModeJsonConfig.channelId)) {
        errorsArray.push(i18n('channel ID'))
    }
    if (isNullOrUndefinedOrEmpty(updateModeJsonConfig.initialPFD) || updateModeJsonConfig.initialPFD>1) {
        errorsArray.push(i18n('channel initial PFD'))
    }
    if (updateModeJsonConfig.validationInterval) {
        if (isNullOrUndefinedOrEmpty(updateModeJsonConfig.validationInterval.minValue)) {
            errorsArray.push(i18n('channel min interval'))
        }
        if (isNullOrUndefinedOrEmpty(updateModeJsonConfig.validationInterval.maxValue)) {
            errorsArray.push(i18n('channel max interval'))
        }
    } else {
        errorsArray.push(i18n('channel validation interval'))
    }
        if (updateModeJsonConfig.rules) {
        updateModeJsonConfig.rules.forEach((rule, index) => {
            if (isNullOrUndefinedOrEmpty(rule.resultantPfd)) {
                errorsArray.push(`${i18n('channel')} ${index + 1}st ${i18n('rule')}, ${i18n('resultant PFD')}`)
            }

            if (isNullOrUndefinedOrEmpty(rule.threshold)) {
                errorsArray.push(`${i18n('channel')} ${index + 1}st ${i18n('rule')} , threshold `)
            }
            if (rule.resultantPfd>1) {
                errorsArray.push(`${i18n('channel')} ${index + 1}st ${i18n('rule')} , ${i18n('resultant PFD should not be more than 1')}`)
            }
        })
    } else {
        errorsArray.push(i18n('channel rules'))
    }

    return errorsArray
}

const quantitativeLiveApiPresenter: IUpdateModeFrontPresenter = {
    label: 'Quantitative Ruled Channel',
    method: 'QUANTITATIVE',
    component: QuantitativeRuledChannelsApi,
    updateModeCode: 'quantitative_ruled_channel',
    validationFunction: requestValidationArray
}

serviceLocator.getService('dra:updatemodefrontservice').then((updateModeFrontAPI: unknown) => {
    try {
        ;(updateModeFrontAPI as UpdateModeFrontAPI).addUpdateModeFrontPresenter(quantitativeLiveApiPresenter)
        logger.info('front sucesseful registered to DRA engines')
    } catch (e) {
        logger.error(e)
    }
})
